import axios from "axios";

const api = axios.create({
    //baseUrl: 'http://localhost:37429/api/'
    baseUrl: 'http://monitoramento.prosinos.rs.gov.br/api/'
});

export default api;
